<template>
  <div class="home">
    <EncabezadoRecuperacionPass></EncabezadoRecuperacionPass>

    <div id="content" class="snap-content bg-home">
      <div class="container">
        <div class="header-clear mt-15"></div>
        <div class="itemList-header"><h1>Cambiar contraseña</h1></div>
        <div v-if="nuevaContraneniaEstablecidaCorrectamente">
          Nueva contraseña establecida correctamente.
        </div>
        <div v-else class="item-Form">
          <div class="panel-body">
            <form
              class="form-horizontal"
              id="formForgotPassword"
              @submit.prevent="establecerNuevaContrasenia"
            >
              <div
                class="validation-summary-valid text-danger"
                data-valmsg-summary="true"
              >
                <ul>
                  <li v-if="!erroresValidacionContrasenia.cumplePatron">
                    La contraseña no cumple el patrón
                  </li>
                  <li v-if="!erroresValidacionContrasenia.confirmacionCorrecta">
                    Las contraseñas indicadas no son iguales
                  </li>
                </ul>
              </div>
              <div class="form-group">
                <div class="col-md-4">
                  <label class="control-label" for="password"
                    >Nueva contraseña</label
                  >
                  <input
                    class="form-control"
                    id="password"
                    name="password"
                    type="password"
                    ref="password"
                    v-model="contrasenia"
                    required
                  />
                </div>
                <div class="col-md-4">
                  <label class="control-label" for="confirmPassword"
                    >Repita nueva contraseña</label
                  >
                  <input
                    class="form-control"
                    id="confirmPassword"
                    name="confirmPassword"
                    type="password"
                    v-model="confirmacionContrasenia"
                    required
                  />
                </div>
              </div>
              <div class="row" style="margin-left: 0px">
                <p>
                  La contraseña debe tener al menos 8 caracteres (con mayúsculas
                  y minúsculas) que incluyan al menos un número y un carácter
                  especial ($@!%*?&+)
                </p>
              </div>
              <div class="form-group">
                <div class="col-xs-12">
                  <input
                    type="submit"
                    class="btn btn-primary"
                    value="Cambiar"
                    style="margin-right: 5px"
                  />
                  <input
                    type="button"
                    class="btn btn-primary"
                    value="Cancelar"
                    @click="$router.push('/login')"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import EncabezadoRecuperacionPass from "@/components/EncabezadoRecuperacionPass.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "RecuperacionContrasenia",
  components: {
    EncabezadoRecuperacionPass,
    Footer,
  },
  data() {
    return {
      contrasenia: "",
      confirmacionContrasenia: "",
      erroresValidacionContrasenia: {
        cumplePatron: true,
        confirmacionCorrecta: true,
      },
    };
  },
  beforeCreate() {
    let pid = this.$route.query.pid;
    this.$store.dispatch({
      type: "validarPeticionPass",
      pid: pid,
    });
  },
  created() {
    this.$store.commit("establecerNuevaContraseniaEstablecida", false);
  },
  mounted() {
    document.body.classList.remove("bg-login");
    document.body.classList.remove("login-page");
    this.$refs.password.focus();
  },
  methods: {
    establecerNuevaContrasenia() {
      let resultado = true;

      this.erroresValidacionContrasenia.cumplePatron = true;
      this.erroresValidacionContrasenia.confirmacionCorrecta = true;

      if (!this.validarContrasenia()) {
        this.erroresValidacionContrasenia.cumplePatron = false;
        resultado = false;
      }

      if (!this.comprobarConfirmacionContrasenia()) {
        this.erroresValidacionContrasenia.confirmacionCorrecta = false;
        resultado = false;
      }

      if (resultado) {
        this.$store.dispatch({
          type: "establecerNuevaContrasenia",
          pid: this.$route.query.pid,
          contrasenia: this.contrasenia,
        });
      }
    },
    validarContrasenia() {
      const patron =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&+])[A-Za-z\d@$!%*?&+]{8,}$/;
      if (this.contrasenia.match(patron)) {
        return true;
      }
      return false;
    },
    comprobarConfirmacionContrasenia() {
      if (this.contrasenia.trim() === this.confirmacionContrasenia.trim()) {
        return true;
      }
      return false;
    },
  },
  computed: {
    nuevaContraneniaEstablecidaCorrectamente: function () {
      return this.$store.state.nuevaContraseniaEstablecida;
    },
  },
};
</script>

<style>
@import "../assets/styles/home.css";
</style>
